/* React */
import React from "react";

/* React Router */
import { useHistory } from "react-router-dom";

/* Stylesheet */
import styles from "./LinkButton.module.scss";

/* Interfaces */
interface LinkButtonProps {
  label: string;
  disabled?: boolean;
  path?: string;
}

const LinkButton: React.FC<LinkButtonProps> = ({
  label,
  disabled,
  path,
}) => {
  const history = useHistory();

  const handleClick = () => {
    if (!disabled) {
      history.push(path!);
    }
  };

  return (
    <div
      className={`${styles.link_button} ${
        disabled ? styles.disabled : ""
      }`}
      onClick={handleClick}
    >
      <div className={styles.label}>{label}</div>
    </div>
  );
};

export default LinkButton;
